import { Target } from "lucide-react";
import {
  StrategicHealthParamsSchema,
  defaultStrategicHealthParams,
  type StrategicHealthParams,
} from "@playbookai/widget-schemas";
import { registerWidget } from "../registry.js";
import type { SqlWidgetDef } from "../types.js";
import { StrategicHealthWidget } from "./Component.js";

/**
 * Strategic Health — dashboard data widget (Strategy, full-width). Self-contained:
 * `TView` defaults to `TParams` (`{ stats? }`) — the stat cards render straight from
 * the saved params (seeded by the mock today). No per-instance editor.
 */
export const strategicHealthDef: SqlWidgetDef<StrategicHealthParams> = {
  kind: "strategicHealth",
  label: "Strategic Health",
  modes: ["dashboard"],
  singleton: true,
  defaultSize: { w: 960, h: 200 },
  defaultParams: defaultStrategicHealthParams,
  Component: StrategicHealthWidget,
  storage: "sql",
  schema: StrategicHealthParamsSchema,
  accent: "emerald",
  icon: Target,
  subtitle: "Top-line transformation KPIs",
  defaultRoster: false,
  category: "single",
  layout: { col: "full", row: 1, width: 960, height: 200 },
  dashboard: {
    icon: Target,
    defaultWidth: "full",
    category: "Strategy",
  },
};

registerWidget(strategicHealthDef);
